import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useAgencies = (includeOrgDetails = false) => {
  const params = includeOrgDetails ? { include_orgs: includeOrgDetails } : {};

  return useQuery(
    queryOptions({
      queryKey: [{ entity: "agencies" }],
      queryFn: async () =>
        await apiClient.getAgencies({
          queries: params,
        }),
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    }),
  );
};
